//
// features.js
//
// Copyright (c) 2015 by Curalate, Inc.
//

((() => {
    angular.module('curalate').controller('FeaturesController', ['$scope', 'FeaturesService', 'FEATURES_UTILS', 'FeaturesApiService',

        ($scope, FeaturesService, FEATURES_UTILS, FeaturesApiService) => {

            const VIBE_PACKAGES = {
                SAMPLING: {
                    name: 'Sampling',
                    packages: {
                        SAMPLING: 'Sampling'
                    }
                },
                CM: {
                    name: 'CM',
                    packages: {
                        CM_ESSENTIALS: 'CM Essentials',
                        CM_ADVANCED: 'CM Advanced',
                        CM_ENTERPRISE: 'CM Enterprise',
                    }
                },
                COM: {
                    name: 'COM',
                    packages: {
                        COM_ESSENTIALS: 'Com Essentials',
                        COM_ADVANCED: 'Com Advanced',
                        COM_ENTERPRISE: 'Com Enterprise',
                    }
                },
                VSN: {
                    name: 'VSN',
                    packages: {
                        VSN_PACKAGE: 'VSN Package',
                        VSN_ADDON_FOR_BRAND: 'VSN Add-On for Brand',
                        VSN_ADDON_FOR_RETAILER: 'VSN Add-On for Retailers'
                    }
                }
            };

            // Scope bound functions and variables
            $scope.model = {
                viewName: FEATURES_UTILS.viewNames[FEATURES_UTILS.getPageParams().view].name,
                pageParams: FEATURES_UTILS.getPageParams(),
                featuresList: null,
                hiddenFeaturesList: null,
                clientsWithFeature: null,
                clientDetails: null,
                clientFeatureDetails: null,
                buttonsDisabled: false,
                featuresDisplayList: ['OptInReleased', 'Released', 'Gamma', 'Dogfood', 'Dev', 'Deprecated'],
                clientFeaturesDisplayList: ['OptInReleased', 'Released', 'Deprecated'],
                clientFeatureError: null,
                featureTiers: [
                    'Social Pro',
                    'Collect - Display (Essentials)',
                    'Collect - Display (Advanced)',
                    'Collect - Display (Enterprise)',
                    'Collect - Display - Distribute (Essentials)',
                    'Collect - Display - Distribute (Advanced)',
                    'Collect - Display - Distribute (Enterprise)',
                    'Collect - Distribute (Essentials)',
                    'Collect - Distribute (Advanced)',
                    'Collect - Distribute (Enterprise)',
                    'Collect - Display - Receive (Essentials)',
                    'Collect - Display - Receive (Advanced)',
                    'Collect - Display - Receive (Enterprise)'
                ],
                additiveFeaturesPackages: [
                    ...Object.values(VIBE_PACKAGES.SAMPLING.packages),
                    ...Object.values(VIBE_PACKAGES.CM.packages),
                    ...Object.values(VIBE_PACKAGES.COM.packages),
                    ...Object.values(VIBE_PACKAGES.VSN.packages)
                ],
                vibeFeaturesPackages: VIBE_PACKAGES,
                selectedTier: null,
                // We want all clients to enable this pkg when using the new provisioning flow
                selectedTiers: [VIBE_PACKAGES.SAMPLING.packages.SAMPLING],
                tierPreview: null,
                featuresAdded: null,
                featuresRemoved: null,
                retainedUnReleasedFeatures: null,
            };

            $scope.model.toggleSelectedTier = (tier) => {
                if ($scope.model.selectedTiers.includes(tier)) {
                    $scope.model.selectedTiers = _.without($scope.model.selectedTiers, tier);
                } else {
                    $scope.model.selectedTiers.push(tier);
                }
            }

            $scope.model.setListAll = all => {
                FEATURES_UTILS.setListAllParam(all);
            };

            $scope.model.setView = view => {
                FEATURES_UTILS.setViewParam(view);
            };

            $scope.model.updateFeatureParam = $event => {
                if ($event.which === 13) {
                    FEATURES_UTILS.setFeatureParam($scope.model.pageParams.feature);
                }
            };

            $scope.model.updateClientParam = $event => {
                if ($event.which === 13) {
                    FEATURES_UTILS.setClientParam($scope.model.pageParams.client);
                }
            };

            // This method is used to change the value of $scope.model.outstandingRequest
            // In order to prevent the loading indicator from constantly popping in and
            // out, we'll wait 500ms before setting 'outstandingRequest' to false. If the
            // value is subsequently changed to 'true', we'll clear the request to
            // make the value 'false'.
            const changeOutstandingRequestStatus = outstandingRequestExists => {
                if (outstandingRequestExists) {
                    clearTimeout($scope.model.outstandingRequestTimeout);
                    $scope.model.outstandingRequest = outstandingRequestExists;
                } else {
                    $scope.model.outstandingRequestTimeout = setTimeout(() => {
                        $scope.$apply(() => {
                            $scope.model.outstandingRequest = outstandingRequestExists;
                        });
                    }, 500);
                }
            };

            $scope.model.isAddOnFeaturePackage = (tier) => {
                return $scope.model.additiveFeaturesPackages.includes(tier)
            }

            const fetchFeatures = () => {
                $scope.model.clientsWithFeature = null;
                changeOutstandingRequestStatus(true);
                FeaturesService.getFeaturesListAsync().then(data => {
                    $scope.model.featuresList = data;
                }, err => {
                    alert(err);
                }).finally(() => {
                    changeOutstandingRequestStatus(false);
                });
            };

            const fetchClientsWithFeature = feature => {
                if (feature === undefined) return;
                $scope.model.clientsWithFeature = null;
                changeOutstandingRequestStatus(true);
                FeaturesService.getClientsWithFeatureListAsync(feature).then(data => {
                    $scope.model.clientsWithFeature = data;
                    if (data.length === 0) {
                        $scope.model.clientFeatureError = `No clients are opted in to feature ${feature}`;
                        $scope.model.clientsWithFeature = null;
                    }
                }, err => {
                    $scope.model.clientFeatureError = err;
                }).finally(() => {
                    changeOutstandingRequestStatus(false);
                });
            };

            const fetchClientFeatures = (client, force) => {
                if (client === undefined) return;
                $scope.model.clientFeatureError = null;
                changeOutstandingRequestStatus(true);

                if ($scope.model.pageParams.listAll === '1') {
                    $scope.model.clientFeaturesDisplayList = ['OptInReleased', 'Gamma', 'Released', 'Deprecated'];
                } else {
                    $scope.model.clientFeaturesDisplayList = ['OptInReleased', 'Released', 'Deprecated'];
                }

                FeaturesService.getClientFeaturesListAsync(client, force).then(data => {
                    let modifiedMap = null;

                    if ($scope.model.pageParams.listAll === '1') {
                        modifiedMap = _.groupBy(data, detail => detail.stage);
                    } else {
                        // if not showing all, remove Gamma features.
                        const modifiedList = _.filter(data, df => !(_.contains($scope.model.hiddenFeaturesList, df.featureId) || df.stage === 'Gamma'));
                        modifiedMap = _.groupBy(modifiedList, detail => detail.stage);
                    }

                    $scope.model.clientFeatureDetails = modifiedMap;
                }, err => {
                    $scope.model.clientFeatureError = err;
                }).finally(() => {
                    changeOutstandingRequestStatus(false);
                    $scope.model.buttonsDisabled = false;
                });

                FeaturesApiService.getClientDetailsAsync(client).then(details => {
                    $scope.model.clientDetails = details;
                }, () => {
                    // do nothing.  invalid client will be thrown by getClientFeaturesListAync too
                });
            };

            const showFailureModal = (errorMsg) => {
                swal('Update failed!', errorMsg, 'error');
            };

            $scope.model.fetchTierImpact = (client, selectedTier) => {
                if (!client || !$scope.model.selectedTier) {
                    return;
                }
                changeOutstandingRequestStatus(true);
                FeaturesApiService.getFeatureTierDiffAsync(client, selectedTier).then(data => {
                    $scope.model.tierPreview = data.tierPreview;
                    $scope.model.featuresAdded = data.newFeatures;
                    $scope.model.featuresRemoved = data.lostFeatures;
                    $scope.model.retainedUnReleasedFeatures = data.retainedUnReleasedFeatures;
                }, err => {
                    $scope.model.clientFeatureError = err;
                }).finally(() => {
                    changeOutstandingRequestStatus(false);
                    $scope.model.buttonsDisabled = false;
                });
            };

            $scope.model.fetchFeatureSelectionDiff = (client) => {
                if (!client) {
                    return;
                }
                changeOutstandingRequestStatus(true);

                FeaturesApiService.getFeatureSelectionDiffAsync(client, $scope.model.selectedTiers).then(data => {
                    $scope.model.tierPreview = data.tierPreview;
                    $scope.model.featuresAdded = data.newFeatures;
                    $scope.model.featuresRemoved = data.lostFeatures;
                    $scope.model.retainedUnReleasedFeatures = data.retainedUnReleasedFeatures;
                }, err => {
                    $scope.model.clientFeatureError = err;
                }).finally(() => {
                    changeOutstandingRequestStatus(false);
                    $scope.model.buttonsDisabled = false;
                });
            };

            $scope.model.setFeatureTier = (client, selectedTier) => {
                if (!client || !$scope.model.selectedTier) {
                    return;
                }

                changeOutstandingRequestStatus(true);
                FeaturesApiService.asyncSetClientFeatureTier(client, selectedTier).then(() => {
                    fetchClientFeatures(client, true);
                }, err => {
                    showFailureModal(err);
                }).finally(() => {
                    changeOutstandingRequestStatus(false);
                    $scope.model.buttonsDisabled = false;
                });
            };

            $scope.model.setSelectedTiers = (client) => {
                if (!client || !$scope.model.selectedTiers) {
                    return;
                }

                changeOutstandingRequestStatus(true);
                FeaturesApiService.asyncSetSelectedTiers(client, $scope.model.selectedTiers).then(() => {
                    fetchClientFeatures(client, true);
                }).catch( err => {
                    showFailureModal(err);
                }).finally(() => {
                    changeOutstandingRequestStatus(false);
                    $scope.model.buttonsDisabled = false;
                });
            };

            $scope.model.setClientValue = (client, feature, value) => {
                if (isNaN(parseInt(value))) {
                    return;
                }

                $scope.model.buttonsDisabled = true;
                changeOutstandingRequestStatus(true);
                FeaturesApiService.asyncSetClientFeatureValue(client, feature, parseInt(value)).then(() => {
                    fetchClientFeatures(client, true);
                }, err => {
                    showFailureModal(err);
                }).finally(() => {
                    changeOutstandingRequestStatus(false);
                    $scope.model.buttonsDisabled = false;
                });
            };

            $scope.model.optinClientFeature = (client, feature) => {
                $scope.model.clientsWithFeature = null;
                $scope.model.buttonsDisabled = true;
                changeOutstandingRequestStatus(true);
                FeaturesApiService.asyncSetClientFeatureActionOptin(client, feature).then(() => {
                    fetchClientFeatures(client, true);
                }, err => {
                    showFailureModal(err);
                }).finally(() => {
                    changeOutstandingRequestStatus(false);
                    $scope.model.buttonsDisabled = false;
                });
            };

            $scope.model.removeOptinClientFeature = (client, feature) => {
                $scope.model.clientsWithFeature = null;
                $scope.model.buttonsDisabled = true;
                changeOutstandingRequestStatus(true);
                FeaturesApiService.asyncRemoveClientFeatureAction(client, feature).then(() => {
                    fetchClientFeatures(client, true);
                }, err => {
                    showFailureModal(err);
                }).finally(() => {
                    changeOutstandingRequestStatus(false);
                    $scope.model.buttonsDisabled = false;
                });
            };

            $scope.model.deleteClient = client => {
                $scope.model.clientsWithFeature = null;
                $scope.model.buttonsDisabled = true;
                changeOutstandingRequestStatus(true);
                if (confirm('Are you sure you want to delete this client??')) {
                    FeaturesApiService.asyncDeleteClient(client).then(() => {
                        fetchClientFeatures(client, true);
                    }, err => {
                        showFailureModal(err);
                    }).finally(() => {
                        changeOutstandingRequestStatus(false);
                        $scope.model.buttonsDisabled = false;
                    });
                } else {
                    changeOutstandingRequestStatus(false);
                    $scope.model.buttonsDisabled = false;
                }
            };

            $scope.model.freezeClient = client => {
                $scope.model.clientsWithFeature = null;
                $scope.model.buttonsDisabled = true;
                changeOutstandingRequestStatus(true);
                if (
                    confirm(`Are you sure you want to freeze this client??  This will freeze ALL clients in the ${$scope.model.clientDetails.groupName} group!`)
                ) {
                    FeaturesApiService.asyncFreezeClient(client).then(() => {
                        fetchClientFeatures(client, true);
                    }, err => {
                        showFailureModal(err);
                    }).finally(() => {
                        changeOutstandingRequestStatus(false);
                        $scope.model.buttonsDisabled = false;
                    });
                } else {
                    changeOutstandingRequestStatus(false);
                    $scope.model.buttonsDisabled = false;
                }
            };

            $scope.model.getClientsWithFeature = featureId => {
                $scope.model.clientsWithFeature = null;
                $scope.model.buttonsDisabled = true;
                changeOutstandingRequestStatus(true);
                FeaturesApiService.getClientsWithFeature(featureId).then(data => {
                    $scope.model.clientsWithFeature = data;
                }, err => {
                    $scope.model.clientFeatureError = err;
                }).finally(() => {
                    changeOutstandingRequestStatus(false);
                    $scope.model.buttonsDisabled = false;
                });
            };

            const initPage = () => {
                FeaturesApiService.getHiddenFeaturesAsync().then(hide => {
                    $scope.model.hiddenFeaturesList = hide.featuresToHide;
                    if ($scope.model.pageParams.view === 'features') {
                        fetchFeatures();
                    } else if ($scope.model.pageParams.view === 'clientfeatures') {
                        fetchClientFeatures($scope.model.pageParams.client, false);
                    } else if ($scope.model.pageParams.view === 'clientswithfeature') {
                        fetchClientsWithFeature($scope.model.pageParams.feature);
                    }
                });
            };

            // Page initialization
            initPage();
        },
    ]);
}))();
